<script>
  import { styles } from '../../../helper'

  export let data
  export let onClick
  export let left = true
  export let right = false

  const {
    title = '',
    start = false,
    color = 'gray',
    srcThumb,
    srcsetThumb,
  } = data
</script>

<div class="grow" on:click={onClick}>
  <div class="container" class:start use:styles={{ color }}>
    <img class="image" class:start src={srcThumb} srcset={srcsetThumb} />
    <div class="heading" class:left class:right use:styles={{ color: color }}>
      {#if title}
        <p>
          {title || ''}
        </p>
      {/if}
      {#if start}
        <p>start</p>
      {/if}
    </div>
  </div>
</div>

<style lang="scss">
  .grow {
    transform-origin: center center;
    transition: all 0.2s ease-in-out;
    width: 100%;
    height: 100%;
  }
  .grow:hover {
    cursor: pointer;
    transform: scale(1.2);
  }
  .container {
    box-sizing: border-box;
    border: var(--color) solid 0.5vw;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    padding: 0;
    /* transform: translateX(-50%) translateY(-50%); */
    @media screen and (min-width: 800px) {
      border-width: 4px;
    }
  }
  .image {
    box-sizing: border-box;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .start {
    /* width: 120%; //80px;
    height: 120%; //80px; */
    transform: scale(1.25);
    padding: 8%;
  }
  .heading {
    position: absolute;
    color: var(--color);
    width: 100%;
    top: 45%;
    line-height: 1.1;
    text-align: left;
    font-style: italic;
    font-size: 1.5vw;
    @media screen and (min-width: 800px) {
      font-size: 12px;
    }
  }
  .right {
    left: 10vw;
    @media screen and (min-width: 800px) {
      left: 80px;
    }
  }
  .left {
    right: 6.5vw;
    @media screen and (min-width: 800px) {
      right: 56px;
    }
  }
</style>
